import { render, staticRenderFns } from "./fahuolist_expand.vue?vue&type=template&id=52379750&scoped=true"
import script from "./fahuolist_expand.vue?vue&type=script&lang=js"
export * from "./fahuolist_expand.vue?vue&type=script&lang=js"
import style0 from "./fahuolist_expand.vue?vue&type=style&index=0&id=52379750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52379750",
  null
  
)

export default component.exports